import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import {
    Form,
    FormActions,
    FormFields,
    FormMultiselectDropdown,
    FormTextField,
    Stack,
    mapToDropdownOption,
    useNotifications
} from "sprint-common-web";

import { useAdminApi } from "../../../../../common/api/admin-api/useAdminApi";
import { UserListingContext } from "../../../context/UserListingContext";
import { UserItem } from "../../UsersListing";

export interface EditUserFormProps {
    item: UserItem;
    onCancel(): void;
    onSubmit(): void;
}

export interface EditUserFormInputs {
    name: string;
    originatorIds: string[];
}

export const EditUserForm: React.FC<EditUserFormProps> = (props: EditUserFormProps) => {
    const { item, onCancel, onSubmit } = props;
    const { originators, updateUser: updateUserInContext } = useContext(UserListingContext);
    const { updateUser } = useAdminApi();
    const { success } = useNotifications();

    const { errors, formState, control, reset, handleSubmit } = useForm<EditUserFormInputs>({
        defaultValues: {
            name: item.name,
            originatorIds: item.originators.map((p) => p.id)
        },
        criteriaMode: "all"
    });

    const handleEditUserADFS = async (inputs: EditUserFormInputs) => {
        await updateUser({ name: inputs.name, originatorIds: inputs.originatorIds });
        success("User updated");
        updateUserInContext(inputs.name, inputs.originatorIds);
        onSubmit();
        reset();
    };

    const handleCancelButtonClick = () => {
        reset();
        onCancel();
    };

    return (
        <Stack>
            <Form onSubmit={handleSubmit(handleEditUserADFS)}>
                <Stack verticalAlign="space-between">
                    <FormFields>
                        <FormTextField
                            label="Name"
                            control={control}
                            name="name"
                            errors={errors}
                            rules={{
                                required: "Name is required field"
                            }}
                        />

                        <FormMultiselectDropdown
                            options={originators.map((org) => mapToDropdownOption(org))}
                            label="Originators"
                            control={control}
                            name={"originatorIds"}
                            errors={errors}
                        />
                    </FormFields>
                    <FormActions
                        isLoading={formState.isSubmitting || formState.isValidating}
                        onCancel={handleCancelButtonClick}
                    />
                </Stack>
            </Form>
        </Stack>
    );
};
